const initialState = {
    triggers: [],
    trigger: null,
    isCreatingTrigger: false,
    isReadingTriggers: false,
    distribution_users: [],
    isReadingDistributionUsers: false,
    isUpdatingCap: false,
    isReadingUniqueRule: false,
    isUniqueRule: null,
    isReadingTrigger: false,
    isUpdatingTrigger: false,

    automation_product_limits: {},
    isReadingAutomationProductLimits: false
}

export default initialState;
